import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RegistrationService } from 'src/app/shared/services/registration.service';
import { environment } from 'src/environments/environment';
import { Common, Avail } from 'src/app/common';
import { ToastrService } from 'ngx-toastr';

declare let $: any;

@Component({
  selector: 'app-vitals',
  templateUrl: './vitals.component.html',
  styleUrls: ['./vitals.component.css']
})
export class VitalsComponent implements OnInit {

  vitalsList: any = [];
  dtRender:boolean;
  orgn = window.location.href.includes('localhost') ? environment.applicationURL : window.origin;
  @Input() bdId: any;
  @Input() is_self: any;
  @Input() fmbdId :any
  isEnableECGStethoscopeInVH: boolean=false;

  constructor(public activeModal: NgbActiveModal, private regService: RegistrationService, private toastr: ToastrService) { }

  ngOnInit(): void {
    this.getAll()
    this.getFeaturePermission();
  }
  getFeaturePermission() {
    var featureList=[]
    featureList = JSON.parse(localStorage.getItem('featuresList'));
    for (let i = 0; i < featureList.length; i++) {
      if (featureList[i].feature_id.feature_name == "EnableECGStethoscopeInVH") {
        this.isEnableECGStethoscopeInVH = featureList[i].patient;
      }
      
    }

  }

  
  getAll() {
    this.dtRender=false
    this.regService.getByAllVitals(this.bdId, this.is_self).subscribe(res => {
      if (res?.status === "OK") {
        if (res?.data == null || res?.data.length == 0) {
          this.toastr.info('No records available');
          this.dtRender=true
          this.vitalsList = [];
        }
        else
          this.vitalsList = res.data;
          this.vitalsList.forEach((el) => {
            if (!el.bmi && el.height && el.weight) {
              const heightInMeters = el.height / 100; // convert cm → m
              el.bmi = +(el.weight / (heightInMeters * heightInMeters)).toFixed(
                2
              ); // round to 2 decimals
            }
            // if(el.bmi){
            switch (true) {
              case el.bmi <= 18.5:
                el.bmiName = 'Underweight';
                el.bmi = el.bmi;
                el.color = '#0000ff'; // blue for 'Underweight'
                break;

              case el.bmi <= 24.99:
                el.bmiName = 'Normal Weight';
                el.bmi = el.bmi;
                el.color = '#008000'; // green for 'Normal Weight'
                break;

              case el.bmi <= 29.99:
                el.bmiName = 'Overweight';
                el.bmi = el.bmi;
                el.color = '#9acd32'; // yellow-green for 'Overweight'
                break;

              case el.bmi <= 34.99:
                el.bmiName = 'Obesity (Class I)';
                el.bmi = el.bmi;
                el.color = '#ffa500'; // orange for 'Obesity (Class I)'
                break;

              case el.bmi <= 39.99:
                el.bmiName = 'Obesity (Class II)';
                el.bmi = el.bmi;
                el.color = '#ff4500'; // orange-red for 'Obesity (Class II)'
                break;

              default:
                el.bmiName = 'Greater Morbid Obesity';
                el.bmi = el.bmi;
                el.color = '#8b0000'; // dark red for 'Greater Morbid Obesity'
                break;
            }
            // }
          });
          this.dtRender=true
        // if (this.is_self)
        // {
         
        //   this.vitalsList = result.filter(f => f.beneficiary_member_id == null); 
        //   // if(this.vitalsList.length==0){
        //     this.dtRender=true;
        //   // } 
        // }
         
        // else{

        //   this.vitalsList = result.filter(f => f.beneficiary_member_id == this.bdId);
        //   // if(this.vitalsList.length==0){
        //     this.dtRender=true;
        //   // } 
        // }

        
        // setTimeout(() => $(`#vitalTable`).DataTable({ destroy: true }));
      }
      console.log("vitallist",this.vitalsList);
      
    });
  }

  onViewDoc(fileTypeId: number, res: any) {
    let link = document.createElement("a"), filePath = '', docPath = '', docLen = 0;
    if (res.beneficiary_member_id == null) {
      docLen = res.beneficiary_vital_documents.filter(f => f.file_type_id == fileTypeId).length;
      if (docLen > 0)
        docPath = res.beneficiary_vital_documents.filter(f => f.file_type_id == fileTypeId)[docLen-1]?.document_path ?? '';
    }
    else {
      docLen = res.beneficiary_member_vital_documents.filter(f => f.fileTypeId == fileTypeId).length;
      if (docLen > 0)
        docPath = res.beneficiary_member_vital_documents.filter(f => f.fileTypeId == fileTypeId)[docLen-1]?.documentPath ?? '';
    }
    if (docPath != '') {
      filePath = `${this.orgn}/${environment.viewFilePath}${res.beneficiary_member_id == null?Avail.BnfcryTxt:Avail.MemDocsTxt}${docPath.split('_')[0]}/${fileTypeId==17?environment.ecgText:environment.audioText}${docPath}`;
      link.setAttribute('href', filePath) ,link.setAttribute('visibility', 'hidden'), link.setAttribute('display', 'none'), link.setAttribute('target', '_blank'), document.body.appendChild(link), link.click();
    }
    else
      this.toastr.info('No Files found');
  }

}